
import storage from "redux-persist/lib/storage";
import { encryptTransform } from 'redux-persist-transform-encrypt';


const encryptor = encryptTransform({
  secretKey: 'Super-Secret-key-jrtec',
  onError: function (error) {
    // Handle the error.
  },
})
export const persistConfig = {
  key: "root",
  storage,
  whitelist: ["usertoken"],
  transforms: [encryptor] ,
};